import axios from 'axios';
import user_json from '@/services/users.json'
import api from '@/api'
axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';



let url   =  location.hostname; //`jcae.guardian.alicesecurity.co`; // location.hostname; //`10.70.70.10`; // `jcae.guardian.alicesecurity.co`; //
if (url == `.`) {
  url  = `localhost`;
}
let proto = api && api.protocol ? api.protocol : 'http:';  
let port  = process.env.VUE_APP_PORT_API || `9090`; // `80`; // || this.$port;
let URL_  =  proto + '//' + url + ':' + '9090' ;
// console.log("api ", api)
if (api) {  
  url  = api.ip;
  port = api.port;
  URL_ = api.url;
}
/*if (process.env.HOST_BACKEND) {
  url     = process.env.HOST_BACKEND;
}*/




const API_URL = URL_;

class AuthService {
  async login(user) { // jwt


// for test
  /*
  let temp = user_json;
  if (temp.jwt) {
    localStorage.setItem('user', JSON.stringify(temp));
  }
  const t1 = await fetch('src/services/users.json').then( res => {
    console.log(res.text(), 'login')
  })
    return  temp ;
   */ 


  return  axios
      .post(API_URL + '/api/v1/auth/login', { // direction / 'login'

      
        // username: user.email,
        password: user.password,
        // first_names:user.first_names,
        // last_names:user.last_names,

        email: user.email        

      })
      .then(response => {
        
        if (response.data.jwt) {//accessToken
          localStorage.setItem('user', JSON.stringify(response.data));
          
        }
        
        return response.data;
      });
  }

  logout() {
    
    localStorage.removeItem('user');
    const api= API_URL + '/api/v1/auth/logout';
    axios.get(api).then(response => {
      
    }).catch(error=> {})
  }

  register(user) {
    let jwt;
    let domain    = '';
    let workspace = '';
    let lang      = 'en';
    let lang1     = '';
    try{

      if (localStorage.getItem('user')) {         
        jwt = JSON.parse(localStorage.getItem('user'));       
      }
      if (localStorage.getItem('vueml-lang')) {
        lang1 = localStorage.getItem('vueml-lang');       

      }
    }catch(e){
      console.log("Error convert to obj")
    }
    if (api) {
      if (api.domain) {
        domain = api.domain;
      }
      if (api.workspace_domain) {
        workspace = api.workspace_domain;
      }
    }
    if(lang1 == 'spanish') {
      lang = "es";

    }else if(lang1 == 'mongolian'){
      lang = "mn";

    }

    return axios.post(API_URL + '/api/v1/auth/registration', {//signup / users
      Username   : user.username,
      roleId     : user.user_role, //user_role
      first_name : user.first_names,
      last_name  : user.last_names,
      email      : user.email,
      password   : user.password,
      password2  : user.password1,
      workspace,
      domain,
      lang,
      
    },{
        headers : {
          "Authorization" : "Bearer " + jwt.jwt,
          "Content-Type"  : "application/json"
        }

      }).then(response => {
      return response.data;
    
    }).catch(error =>{
      console.log(error, 'error axios')
      return error;
    });
  }

  recover_psw(user) {
    return axios.post(API_URL + '', { //recover psw
      username: user.username,
      password: user.password,
      password1: user.password1,
    }).then(response => {
      return response.data;
    })
  }

  list_permissions(user) {
    let roleId = user && user.roleId ? user.roleId : null; 
    return axios.post(API_URL + "/api/v1/permissions/find", { id : roleId } ).then(res => {
      // console.log("Get permissions ", res)
      return res;
    }).catch(err => {
      console.log("Error get permissions ", )
      return null;
    })
  }
  list_resources(){
     return axios.get(API_URL + "/api/v1/resource").then(res => {
      // console.log("Get resource ", res)
      return res;
    }).catch(err => {
      console.log("Error get permissions ", )
      return null;
    })
  }
  list_users(opt){
    if (opt == "all") {
      return axios.get(API_URL + "/api/v1/users_all/").then(res => {
        // console.log("Get all users ", res)
        return res;
      }).catch(err => {
        console.log("Error get all user ", err )
        return null;
      })
    }
  }
}

export default new AuthService();